// CLAUDE-SYNC: v1.7.20 (2026-10-09) — shared "where is this phleb/driver right
// now" helper used to stamp GPS coordinates on every stop status change and
// on clock in/out.
//
// Problem (Tanaya, Oct 7 Clock-In Audit export): the Event Lat/Lng columns
// were blank, and many clock in/out coordinates were blank too. Each action
// made its own getCurrentPosition() call with a 3 s timeout, which routinely
// expires on laptops/indoors, and the result was silently dropped (null).
//
// Fix: App.js already runs a continuous watchPosition() while a user is
// clocked in. It now records every fix here (rememberPosition). Actions ask
// for getEventCoords(), which returns the most recent fix instantly if it is
// fresh enough, and only falls back to the old one-shot getCurrentPosition()
// (same 3 s timeout as before) when no recent fix exists. Net effect: more
// coordinates captured, and NO added waiting on the Mark Arrived / status /
// clock buttons.
//
// Best-effort only: never throws, returns null if location is unavailable.

const DEFAULT_MAX_AGE_MS = 120000; // accept a fix up to 2 minutes old

let lastFix = null; // { lat, lng, ts }

export function rememberPosition(lat, lng) {
  if (typeof lat !== 'number' || typeof lng !== 'number') return;
  lastFix = { lat, lng, ts: Date.now() };
}

export function getRecentPosition(maxAgeMs = DEFAULT_MAX_AGE_MS) {
  if (!lastFix) return null;
  if (Date.now() - lastFix.ts > maxAgeMs) return null;
  return { lat: lastFix.lat, lng: lastFix.lng };
}

export function getEventCoords({ maxAgeMs = DEFAULT_MAX_AGE_MS, timeoutMs = 3000 } = {}) {
  const recent = getRecentPosition(maxAgeMs);
  if (recent) return Promise.resolve(recent);

  return new Promise((resolve) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      resolve(null);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      () => resolve(null),
      { timeout: timeoutMs, maximumAge: 30000 }
    );
  });
}
